export default __webpack_public_path__ + "static/media/151-door.3512319a.png";